import { getObjectUtil } from 'packages/src'
import logSystemUtil from '../../../../logs/redux/actions/log'
import mergeInstances from '../../../../redux/utils/add/merge-instances'
import updateOldAndNewInstanceReferences from '../../../../redux/utils/add/update-old-and-new-instance-references'
import areInstancesEqualReduxUtil from '../../../../redux/utils/are-instances-equal'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import setUtil from '../../../../../utils/set'

/**
 * Add the `newInstance` to the state.
 *
 * @private
 *
 * @param   {Object} params
 *          {Object} params.state
 *          {Instance} params.model
 *          {Instance|null} params.existingInstance
 * @returns {Object}
 */
export default function addInstance (params) {
  let {
    state,
    instance,
    existingInstance
  } = params

  const newPath = getPathReduxUtil(instance)
  logSystemUtil('addInstance').debug(`newPath=${newPath}`)
  // console.log('newPath: ', newPath)
  if (!newPath) {
    return state
  }

  // The existingInstance doesn't exist, set it
  existingInstance = existingInstance || getObjectUtil(state, newPath)
  // console.log('existingInstance: ', existingInstance)
  if (!existingInstance) {
    return setUtil(state, newPath, instance)
  }

  const oldPath = getPathReduxUtil(existingInstance)
  // console.log('oldPath: ', oldPath)
  // Merge the old existingInstance with the new one

  if (areInstancesEqualReduxUtil(existingInstance, instance)) {
    logSystemUtil('addInstance').debug('[noop] are equal')
    return state
  }

  existingInstance = mergeInstances(existingInstance, instance)
  logSystemUtil('addInstance').debug(`newPath=${newPath}`)
  logSystemUtil('addInstance').debug(`oldPath=${oldPath}`)
  // Update the references pointing to the old existingInstance to the new one
  if (oldPath && oldPath !== newPath) {
    state = updateOldAndNewInstanceReferences({
      state,
      instance,
      oldPath,
      existingInstance
    })
  }
  return setUtil(state, newPath, existingInstance)
}
